import { Outlet } from 'react-router-dom';
import { useUIStore } from '@/stores/uiStore';
import { cn } from '@/lib/utils';
import Sidebar from './Sidebar';
import Header from './Header';

export default function MainLayout() {
  const { sidebarOpen, sidebarCollapsed } = useUIStore();
  
  return (
    <div className="min-h-screen bg-background">
      {/* Sidebar */}
      <Sidebar />
      
      {/* Main Content */}
      <div
        className={cn(
          'transition-all duration-300',
          sidebarOpen
            ? sidebarCollapsed
              ? 'lg:ml-16'
              : 'lg:ml-64'
            : 'lg:ml-0'
        )}
      >
        {/* Header */}
        <Header />
        
        {/* Page Content */}
        <main className="p-4 md:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
      
      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-30 lg:hidden"
          onClick={() => useUIStore.getState().setSidebarOpen(false)}
        />
      )}
    </div>
  );
}
